import AdminListPage from "./components/AdminListPage";
export default function DepositList() {
	return (
		<AdminListPage
			title="Senarai Deposit"
			endpoint="/admin/deposit"
		/>
	);
}
